import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  input: {
    WebkitTextFillColor: `${theme.colors.mainTextColour}`,
    WebkitBoxShadow: `0 0 0 30px ${
      theme.colors.availabilityBackgroundBoxBgColour ||
      (theme.colors.darkMode ? theme.colors.charcoal : theme.colors.white)
    } inset`,
    '&:hover': {
      WebkitTextFillColor: `${theme.colors.mainTextColour}`,
      WebkitBoxShadow: `0 0 0 30px ${
        theme.colors.availabilityBackgroundBoxBgColour ||
        (theme.colors.darkMode ? theme.colors.charcoal : theme.colors.white)
      } inset !important`,
    },
    '&:focus': {
      WebkitTextFillColor: `${theme.colors.mainTextColour}`,
      WebkitBoxShadow: `0 0 0 30px ${
        theme.colors.availabilityBackgroundBoxBgColour ||
        (theme.colors.darkMode ? theme.colors.charcoal : theme.colors.white)
      } inset  !important`,
    },
    '&:active': {
      WebkitTextFillColor: `${theme.colors.mainTextColour}`,
      WebkitBoxShadow: `0 0 0 30px ${
        theme.colors.availabilityBackgroundBoxBgColour ||
        (theme.colors.darkMode ? theme.colors.charcoal : theme.colors.white)
      } inset`,
    },
  },
}));

export default useStyles;
